<div class="container">
  <h1>Mes Ventes</h1>
  <br />
  <ng-container *ngIf="store$ | async as store">
    <h2>Ventes Par Produits</h2>
    <app-sales-stats [store]="store"></app-sales-stats>
    <br />
    <h2>Historique des ventes</h2>
    <app-sales-history [store]="store"></app-sales-history>
  </ng-container>
</div>
